const State = {
  windowWidth: window.innerWidth,
  sidebarStatus: undefined
};
export default State;
